import { Icon } from '@eventbrite/eds-icon';
import React from 'react';
import '../styles/timeline.scss';
import { BenefitsItem } from '../types';

type TimelineWithBenefitsProps = {
    intervalSpeedInMS: number | null;
    items: Array<BenefitsItem>;
    static?: boolean;
};

export const TimelineWithBenefits: React.FC<TimelineWithBenefitsProps> = (
    props,
) => {
    const [activeIndex, setActiveIndex] = React.useState(0);

    React.useEffect(() => {
        let interval: any;

        if (props.intervalSpeedInMS) {
            interval = setInterval(() => {
                setActiveIndex((prev) => (prev + 1) % props.items.length);
            }, props.intervalSpeedInMS);
        }

        return () => clearInterval(interval);
    }, [props.intervalSpeedInMS, props.items.length]);

    const renderItems = () => {
        return props.items.map(({ icon: IconType, heading, info }, idx) => (
            <React.Fragment key={idx}>
                <div className="boost-benefits__timeline-item-container">
                    <div className="boost-benefits_item-icons">
                        <div
                            className={
                                !props.static && idx <= activeIndex
                                    ? 'boost-benefits__timeline_v2--item active'
                                    : 'boost-benefits__timeline_v2--item'
                            }
                        >
                            <Icon type={IconType} />
                        </div>

                        {idx < props.items.length - 1 ? (
                            <div className="boost-benefits__timeline_v2--line">
                                <div className={'timeline-line'} />
                                <div
                                    className={
                                        idx <= activeIndex - 1
                                            ? 'timeline-line draw'
                                            : 'timeline-line'
                                    }
                                />
                            </div>
                        ) : null}
                    </div>
                    <div className="boost-benefits__right-content">
                        <h5 className="eds-text-bm eds-text-weight--heavy">
                            {heading}
                        </h5>
                        <span className="eds-text-bm">{info}</span>
                    </div>
                </div>
            </React.Fragment>
        ));
    };

    return <div className="boost-benefits__timeline_v2">{renderItems()}</div>;
};
